// 面包屑的数据
export default new Map([
  [
    'setup/channel/edit',
    [
      {
        text: '支付渠道',
        to: { name: 'setup/channel' },
      },
      {
        text: '设置参数',
      },
    ],
  ],
  [
    'reconciliation/list/detail',
    [
      {
        text: '对账汇总',
        to: { name: 'reconciliation/list' },
      },
      {
        text: '对账单详情',
      },
    ],
  ],
  [
    'reconciliation/error/detail',
    [
      {
        text: '差错记录',
        to: { name: 'reconciliation/error' },
      },
      {
        text: '差错详情',
      },
    ],
  ],
  [
    'apply/create',
    [
      {
        text: '首页',
        to: { name: 'apply/index' },
      },
      {
        text: '新建应用',
      },
    ],
  ],
  [
    'apply/update',
    [
      {
        text: '首页',
        to: { name: 'apply/index' },
      },
      {
        text: '修改应用',
      },
    ],
  ],
  [
    'apply/detail',
    [
      {
        text: '首页',
        to: { name: 'apply/index' },
      },
      {
        text: '应用配置',
      },
    ],
  ],
  [
    'account/enterprise/edit',
    [
      {
        text: '企业信息',
        to: { name: 'account/enterprise' },
      },
      {
        text: '修改企业信息',
      },
    ],
  ],
  [
    'account/enterprise/edit/name',
    [
      {
        text: '企业信息',
        to: { name: 'account/enterprise' },
      },
      {
        text: '修改企业信息',
        to: { name: 'account/enterprise/edit' },
      },
      {
        text: '修改公司名称',
      },
    ],
  ],
  [
    'account/role/edit/member',
    [
      {
        text: '成员列表',
        to: { name: 'account/role' },
      },
      {
        text: '修改成员信息',
      },
    ],
  ],
  [
    'account/role/edit',
    [
      {
        text: '角色权限',
        to: { name: 'account/role' },
      },
      {
        text: '编辑角色',
      },
    ],
  ],
  [
    'trading/list/detail',
    [
      {
        text: '交易订单查询',
        to: { name: 'trading/list' },
      },
      {
        text: '订单详情',
      },
    ],
  ],
  [
    'trading/refund/detail',
    [
      {
        text: '退款订单管理',
        to: { name: 'trading/refund' },
      },
      {
        text: '订单详情',
      },
    ],
  ],
  [
    'trading/applyRefund',
    [
      {
        text: '退款订单管理',
        to: { name: 'trading/refund' },
      },
      {
        text: '申请退款',
      },
    ],
  ],
]);
